var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 3.55469H9.95312L9.51016 2.31328C9.47955 2.22834 9.42347 2.15491 9.34957 2.10303C9.27567 2.05116 9.18756 2.02336 9.09727 2.02344H4.90273C4.71816 2.02344 4.55273 2.13965 4.49121 2.31328L4.04688 3.55469H2.1875C1.5832 3.55469 1.09375 4.04414 1.09375 4.64844V10.8828C1.09375 11.4871 1.5832 11.9766 2.1875 11.9766H11.8125C12.4168 11.9766 12.9062 11.4871 12.9062 10.8828V4.64844C12.9062 4.04414 12.4168 3.55469 11.8125 3.55469ZM7 9.78906C5.79141 9.78906 4.8125 8.81016 4.8125 7.60156C4.8125 6.39297 5.79141 5.41406 7 5.41406C8.20859 5.41406 9.1875 6.39297 9.1875 7.60156C9.1875 8.81016 8.20859 9.78906 7 9.78906ZM5.6875 7.60156C5.6875 7.94966 5.82578 8.2835 6.07192 8.52964C6.31806 8.77578 6.6519 8.91406 7 8.91406C7.3481 8.91406 7.68194 8.77578 7.92808 8.52964C8.17422 8.2835 8.3125 7.94966 8.3125 7.60156C8.3125 7.25347 8.17422 6.91963 7.92808 6.67348C7.68194 6.42734 7.3481 6.28906 7 6.28906C6.6519 6.28906 6.31806 6.42734 6.07192 6.67348C5.82578 6.91963 5.6875 7.25347 5.6875 7.60156Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.bc7b3d14d98b5fb578f50728155fcb67.svg";
export { ForwardRef as ReactComponent };